import React, { Component } from 'react'
import PropTypes from 'prop-types'
import InputRow from './InputRow'

const ACADEMIC_SUPPORT_OPTIONS = [
  { Id: 'Yes', value: 'Yes' },
  { Id: 'No', value: 'No' }
]

export default class PGAcademicSupport extends Component {
  constructor (props) {
    super(props)
    this.state = {
      academicSupport: props.academicSupport || '',
      academicSupportDetails: props.academicSupportDetails || '',
      error: ''
    }
  }

  componentDidMount () {
    this.props.collectState('PG_AcademicSupport', {
      academicSupport: this.state.academicSupport,
      academicSupportDetails: this.state.academicSupportDetails
    })
  }

  handleChange (field, value) {
    const updated = { ...this.state, [field]: value }
    if (field === 'academicSupport' && value !== 'Yes') {
      updated.academicSupportDetails = ''
    }
    updated.error = ''
    this.setState(updated)
    this.props.collectState('PG_AcademicSupport', {
      academicSupport: updated.academicSupport,
      academicSupportDetails: updated.academicSupportDetails
    })
  }

  handleNext () {
    const { academicSupport, academicSupportDetails } = this.state
    if (!academicSupport) {
      this.setState({ error: 'Please select Yes or No.' })
      return
    }
    if (academicSupport === 'Yes' && !academicSupportDetails) {
      this.setState({ error: 'Please specify your needs.' })
      return
    }
    this.setState({ error: '' })
    this.props.onSave()
  }

  render () {
    const { academicSupport, academicSupportDetails, error } = this.state
    return (
      <div>
        <p style={{ fontSize: 13, color: '#555', marginBottom: 4 }}>
          Does your case require additional academic support due to special learning needs or disabilities?
        </p>
        <InputRow
          rowName='Academic Support'
          name='select'
          value={academicSupport}
          data={ACADEMIC_SUPPORT_OPTIONS}
          required='*'
          errMsg=''
          onChange={(val) => this.handleChange('academicSupport', val)}
        />
        {academicSupport === 'Yes' && (
          <InputRow
            rowName='Please specify your needs'
            name='text'
            value={academicSupportDetails}
            required='*'
            errMsg=''
            onChange={(val) => this.handleChange('academicSupportDetails', val)}
          />
        )}
        {error && <p style={{ color: 'red', fontSize: 12, marginTop: 8 }}>{error}</p>}
        <button className='save' onClick={() => this.handleNext()}>Next</button>
      </div>
    )
  }
}

PGAcademicSupport.propTypes = {
  onSave: PropTypes.func.isRequired,
  collectState: PropTypes.func.isRequired,
  academicSupport: PropTypes.string,
  academicSupportDetails: PropTypes.string
}

PGAcademicSupport.defaultProps = {
  academicSupport: '',
  academicSupportDetails: ''
}
